
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Logger } from "@/utils/Logger";
import { serviceGouv } from "@/core/service/data.gouv/DataGouvApiService";
import { SirenNotFoundError } from "@/core/service/data.gouv/exception/SirenNotFoundError";
import { DataGouvApiError } from "@/core/service/data.gouv/exception/DataGouvApiError";
import { etablissementService } from "@/core/service/licencesnationales/EtablissementService";
import { rulesForms } from "@/core/RulesForm";
import Etablissement from "@/core/Etablissement";
import { Action, Message, MessageType } from "@/core/CommonDefinition";
import Contact from "@/components/etablissement/Contact.vue";
import { LicencesNationalesApiError } from "@/core/service/licencesnationales/exception/LicencesNationalesApiError";
import MessageBox from "@/components/common/MessageBox.vue";
@Component({
  components: { MessageBox, Contact }
})
export default class FormEtablissement extends Vue {
  public metaInfo(): any {
    let titre = "";
    if (this.action === Action.CREATION) {
      titre = "Inscription";
    } else {
      titre = "Modification du compte";
    }
    return {
      meta: [
        {
          name: "description",
          content:
            "Création de compte sur l'application des Licences Nationales"
        }
      ],
      title: titre + " - Licences Nationales"
    };
  }

  etablissement: Etablissement = new Etablissement();
  @Prop() action!: Action;
  @Prop() listeSirenFusion!: Array<string>;
  @Prop() triggerScission!: boolean;
  @Watch("triggerScission")
  onTriggerScission() {
    if (this.action == Action.SCISSION && this.triggerScission) {
      this.validate();
    }
  }
  Action: any = Action;
  rulesForms: any = rulesForms;
  isAdmin: boolean = this.$store.getters.isAdmin();
  tokenrecaptcha: string = "";
  typesEtab: Array<string> = [];
  checkSirenAPI: string = "En attente de vérification";
  checkSirenColor: string = "grey";
  buttonLoading: boolean = false;
  alert: boolean = false;
  error: string = "";
  dialog: boolean = false;
  dialogAvailable: boolean = false;
  isDisableForm: boolean = false;
  returnLink: boolean = false;

  constructor() {
    super();
    if (this.action !== Action.FUSION && this.action !== Action.SCISSION)
      this.etablissement = this.getCurrentEtablissement;
    this.fetchListeType();
    window.scrollTo(0, 0);
  }

  get getCurrentEtablissement(): Etablissement {
    return this.$store.getters.getCurrentEtablissement();
  }

  async fetchListeType() {
    this.$store.dispatch("closeDisplayedMessage");
    await etablissementService
      .listeType()
      .then(result => {
        this.isDisableForm = false;
        this.typesEtab = result;
      })
      .catch(err => {
        Logger.error(err.toString());
        const message: Message = new Message();
        message.type = MessageType.ERREUR;
        if (err instanceof LicencesNationalesApiError) {
          this.isDisableForm = true;
          message.texte =
            "Fonctionnalité momentanement indisponible pour le moment. Réessayer plus tard";
        } else {
          message.texte = "Impossible d'exécuter l'action : " + err.message;
        }
        message.isSticky = true;
        this.$store.dispatch("openDisplayedMessage", message).catch(err => {
          Logger.error(err.toString());
        });
      });
  }

  allerAConnexion(): void {
    this.$store.dispatch("closeDisplayedMessage");
    this.$router.push({ name: "Login" }).catch(err => {
      Logger.error(err);
    });
  }

  allerPageAccueil(): void {
    this.$router.push({ name: "Login" }).catch(err => {
      Logger.error(err);
    });
  }

  /**
   * Récupère le token Google
   * */
  async recaptcha() {
    await this.$recaptchaLoaded();
    this.tokenrecaptcha = await this.$recaptcha("creationCompte");
  }

  async validate() {
    this.buttonLoading = true;
    this.$store.dispatch("closeDisplayedMessage");

    await this.recaptcha();

    const isFormValide = (this.$refs.formCreationCompte as Vue & {
      validate: () => boolean;
    }).validate();

    const isSubFormValide = (this.$refs.formContact as Contact).validate();

    if (this.tokenrecaptcha != null) {
      if (isFormValide && isSubFormValide) {
        this.send();
      } else {
        const message: Message = new Message();
        message.type = MessageType.ERREUR;
        message.texte = "Des champs ne remplissent pas les conditions";

        if (this.checkSirenAPI === "inconnu") {
          message.texte += "<br /> Le SIREN de l'établissement est inconnu";
        }

        message.isSticky = true;
        this.$store.dispatch("openDisplayedMessage", message).catch(err => {
          Logger.error(err.toString());
        });
        // On glisse sur le message d'erreur
        const messageBox = document.getElementById("messageBox");
        if (messageBox) {
          window.scrollTo(0, messageBox.offsetTop);
        }
      }
    }
    this.buttonLoading = false;
  }

  send(): void {
    this.buttonLoading = true;
    this.$store.dispatch("closeDisplayedMessage");

    if (this.action == Action.CREATION) {
      etablissementService
        .creerEtablissement(this.etablissement, this.tokenrecaptcha)
        .then(() => {
          const message: Message = new Message();
          message.type = MessageType.VALIDATION;
          message.texte =
            "Le compte a été enregistré. Pour y accéder, merci de vous authentifier";
          message.isSticky = true;
          this.returnLink = true;
          this.$store.dispatch("openDisplayedMessage", message).catch(err => {
            Logger.error(err.toString());
          });
          this.$router.push("/");
        })
        .catch(err => {
          Logger.error(err.toString());
          const message: Message = new Message();
          message.type = MessageType.ERREUR;
          message.texte = err.message;
          message.isSticky = true;
          this.$store.dispatch("openDisplayedMessage", message).catch(err => {
            Logger.error(err.toString());
          });
          // On glisse sur le message d'erreur
          const messageBox = document.getElementById("messageBox");
          if (messageBox) {
            window.scrollTo(0, messageBox.offsetTop);
          }
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    } else if (this.action == Action.MODIFICATION) {
      etablissementService
        .updateEtablissement(
          this.etablissement,
          this.$store.getters.getToken(),
          this.$store.getters.isAdmin()
        )
        .then(() => {
          const message: Message = new Message();
          message.type = MessageType.VALIDATION;
          message.texte = "Votre compte a bien été modifié";
          message.isSticky = true;
          this.returnLink = true;
          this.$store.dispatch("openDisplayedMessage", message).catch(err => {
            Logger.error(err.toString());
          });
          // On glisse sur le message
          const messageBox = document.getElementById("messageBox");
          if (messageBox) {
            window.scrollTo(0, messageBox.offsetTop);
          }
          if (
            this.etablissement.siren ==
            this.$store.getters.getEtablissementConnecte().siren
          ) {
            this.$store.dispatch(
              "setEtablissementConnecté",
              this.etablissement
            );
          }
        })
        .catch(err => {
          const message: Message = new Message();
          message.type = MessageType.ERREUR;
          message.texte = err.message;
          message.isSticky = true;
          this.$store.dispatch("openDisplayedMessage", message).catch(err => {
            Logger.error(err.toString());
          });
          // On glisse sur le message d'erreur
          const messageBox = document.getElementById("messageBox");
          if (messageBox) {
            window.scrollTo(0, messageBox.offsetTop);
          }
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    } else if (this.action === Action.FUSION) {
      etablissementService
        .fusion(this.$store.getters.getToken(), {
          nouveauEtab: this.etablissement,
          sirenFusionnes: this.listeSirenFusion
        })
        .then(() => {
          this.clear();
          const message: Message = new Message();
          message.type = MessageType.VALIDATION;
          message.texte = "Fusion effectuée.";
          message.isSticky = true;
          this.returnLink = true;
          this.$store.dispatch("openDisplayedMessage", message).catch(err => {
            Logger.error(err.toString());
          });
          this.$router.push({ name: "ListeEtab" }).catch(err => {
            Logger.error(err);
          });
        })
        .catch(err => {
          const message: Message = new Message();
          message.type = MessageType.ERREUR;
          message.texte = err.message;
          message.isSticky = true;
          this.$store.dispatch("openDisplayedMessage", message).catch(err => {
            Logger.error(err.toString());
          });
          // On glisse sur le message d'erreur
          const messageBox = document.getElementById("messageBox");
          if (messageBox) {
            window.scrollTo(0, messageBox.offsetTop);
          }
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    } else if (this.action === Action.SCISSION) {
      this.$emit("send", this.etablissement);
      this.buttonLoading = false;
    }
  }

  /**
   * Fonction de vérification du numéro SIREN
   */
  checkSiren(): void {
    this.$store.dispatch("closeDisplayedMessage");
    this.checkSirenAPI = "En attente de vérification";
    if (this.etablissement.siren) {
      this.checkSirenAPI = "Vérification du SIREN en cours...";
      this.checkSirenColor = "siren-default";
      if (this.etablissement.siren.length === 9) {
        this.dialogAvailable = true;
        serviceGouv
          .checkSiren(this.etablissement.siren)
          .then(data => {
            this.checkSirenAPI = data;
            this.checkSirenColor = "siren-ok";
          })
          .catch(err => {
            Logger.error(err);
            if (err instanceof SirenNotFoundError) {
              this.checkSirenAPI = "Inconnu";
              this.checkSirenColor = "siren-erreur";
            } else if (err instanceof DataGouvApiError) {
              this.checkSirenAPI =
                "Impossible de contacter le service de vérification du numéro SIREN";
              this.checkSirenColor = "siren-erreur";
            } else {
              this.checkSirenAPI = "Erreur interne : " + err.message;
              this.checkSirenColor = "red";
            }
          });
      } else {
        this.dialogAvailable = false;
      }
    }
  }
  clear() {
    this.$store.dispatch("closeDisplayedMessage");
    (this.$refs.formCreationCompte as HTMLFormElement).resetValidation();
    (this.$refs.formContact as Contact).clear();

    if (this.action === Action.MODIFICATION) {
      this.$store.dispatch("setCurrentEtablissement", this.etablissement);
      this.$store.dispatch("closeDisplayedMessage");
      this.$router.push({ name: "Home" }).catch(err => {
        Logger.error(err);
      });
    } else {
      this.etablissement.reset();
      window.scrollTo(0, 0);
    }
  }
}
